// extracted by mini-css-extract-plugin
export default {"wrapper":"EditProduct_wrapper__2U9xm"};